import { Box, Button, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import PaymentRemindersListActions from '../../redux/reducers/payment_reminders_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import NotificationImportantOutlinedIcon from '@material-ui/icons/NotificationImportantOutlined';
import { TableColumns, Translations } from './configuration';
import NavigationConfig from '../../navigation/config';
import useQuery from 'custom_hooks/useQuery';
import PaymentReminderViewModal from './components/datatable/view';

const PaymentRemindersPage = () => {
  // console.log('Render PaymentRemindersPage');
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = useQuery();
  const sortField = query.get('sortField') || TableColumns[0].id;
  const page = Number(query.get('page') || 0);
  const pageSize = Number(query.get('pageSize') || 25);
  const order = (query.get('order') as 'asc' | 'desc') || 'desc';
  const vatNumber = query.get('vatNumber');
  const vatReturnReference = query.get('vatReturnReference');
  const remindedDateFrom = query.get('remindedDateFrom');
  const remindedDateTo = query.get('remindedDateTo');
  const fetchPayload = {
    sortField,
    page,
    pageSize,
    order,
    ...(vatNumber && { vatNumber }),
    ...(vatReturnReference && { vatReturnReference }),
    ...(remindedDateFrom && { remindedDateFrom }),
    ...(remindedDateTo && { remindedDateTo }),
  };

  React.useEffect(() => {
    dispatch(
      PaymentRemindersListActions.fetchPaymentRemindersListListAction(
        fetchPayload
      )
    );
  }, [
    dispatch,
    sortField,
    page,
    pageSize,
    order,
    vatNumber,
    vatReturnReference,
    remindedDateFrom,
    remindedDateTo,
  ]);

  return (
    <div>
      <PaymentReminderViewModal />
      <Paper className={clsx(classes.titleLayout)}>
        <Box display="flex" alignItems={'center'}>
          <NotificationImportantOutlinedIcon
            style={{ marginRight: '.75rem' }}
          />
          <Typography component={'span'} style={{ fontSize: '1.5rem' }}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
        {/* {ROLE === Roles.Admin && (
          <Button
            className={classes.header_actions}
            onClick={generatePaymentRemindersForQuarter}
            disabled={paymentRemindersGenerateStatus === StateStatus.Pending}
          >
            <TranslatedText textMap={Translations.generate_button} />
          </Button>
        )} */}
      </Paper>
      <div className={classes.contentContainer}>
        <div className={classes.tableHeader}>
          <Typography component={'p'} variant={'h5'}>
            <TranslatedText
              textMap={Translations.table_title}
              defaultText={Translations.table_title.English}
            />
          </Typography>
        </div>
        <DatatableList />
        <BackToDashboardPage />
      </div>
    </div>
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      style={{ marginTop: '1rem' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(PaymentRemindersPage);
